// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const Heading1IconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="Heading1Icon" ref={forwardedRef} {...props}>
      <path d="M1.75 4.5h1.555V16H1.75zm.808 4.95h6.33v1.478h-6.33zM8.19 4.5h1.554V16H8.191z" />
      <path d="m14.773 5.486 1.11.626-3.533 1.396-.485-1.006L15.237 4.5h1.1v11.007h-1.564zm-2.534 9.118h6.511V16h-6.511z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const Heading1Icon = /* @__PURE__ */ Object.assign(
  Heading1IconComponent,
  { displayName: 'Heading1Icon' },
);
